import React from "react";

import { Stack, IconButton } from "@mui/material";
import { CloseIcon } from "../../../atoms/icons/close";

export const CloseModalButton = ({ onClick }) => (
  <Stack>
    <IconButton onClick={onClick} sx={{ height: 56, width: 56, padding: 0 }}>
      <CloseIcon />
    </IconButton>
    <span>Close</span>
  </Stack>
);
